module.exports = __webpack_public_path__ + "img/4.accb027b.svg";